import { render } from "./achievementsCarouselDots.vue?vue&type=template&id=ead784c6&scoped=true"
import script from "./achievementsCarouselDots.vue?vue&type=script&lang=js"
export * from "./achievementsCarouselDots.vue?vue&type=script&lang=js"

import "./achievementsCarouselDots.vue?vue&type=style&index=0&id=ead784c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ead784c6"]])

export default __exports__